import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GLOBAL_API_BASE_URL } from '@chk/env-variables';
import { getGlobalAPIHeaders } from '@data/global-api-common';
import { asyncFetch, validateSchema } from '@utility/checkout-utils';

import { GLOBAL_API_ACCOUNT_ACCESS_ENDPOINTS } from '../../constants/endpoints';
import { ACCOUNT_ACCESS_TAGS } from '../../constants/tags';
import { GlobalApiAccountAccessSchema } from '../../schemas/GlobalApiAccountAccess';

import type { PostGlobalApiAccountAccessCancelParams } from './usePostGlobalApiAccountAccessCancel.types';

export const usePostGlobalApiAccountAccessCancel = ({
  accountAccessId,
  voltApp,
  authToken,
  onError,
}: PostGlobalApiAccountAccessCancelParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      asyncFetch(
        `${GLOBAL_API_ACCOUNT_ACCESS_ENDPOINTS.postCancel(accountAccessId)}`,
        {
          method: 'POST',
          headers: getGlobalAPIHeaders({
            authToken,
            voltService: 'ais',
            voltApp,
          }),
        },
        GLOBAL_API_BASE_URL,
        true
      ).then(validateSchema(GlobalApiAccountAccessSchema)),
    onSuccess: (data) => {
      queryClient.setQueryData(
        ACCOUNT_ACCESS_TAGS.GLOBAL_API(accountAccessId),
        data
      );
    },
    onError,
  });
};
